export default {
  "content": "<path d=\"M13.484 16.152h-1.992v-5.64H9.5v-1.5l.72-.06c1.14-.084 1.62-.48 1.74-1.452h1.524v8.652z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.929 4.928c3.905-3.905 10.237-3.905 14.142 0 3.905 3.906 3.905 10.238 0 14.143-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.906-10.237 0-14.143zm12.728 1.415A8.001 8.001 0 106.343 17.659 8.001 8.001 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};